import { Directive, ElementRef, Renderer2, Input, OnInit } from '@angular/core';
import { PermissionsService } from './permissions.service';

@Directive({
  selector: '[appPermissionControl]'
})
export class PermissionControlDirective implements OnInit {
  @Input('appPermissionControl') permissionUid: string;

  constructor(private el: ElementRef, private renderer: Renderer2, private permissionsService: PermissionsService) {}

  ngOnInit() {
    this.applyPermissions();

    // Usar setTimeout para re-aplicar permisos después de un corto tiempo
    setTimeout(() => {
      this.applyPermissions();
    }, 100); // Esperamos 100ms, ajusta según sea necesario

    // Verificar y recuperar rol si es necesario
    this.permissionsService.verifyAndRecoverRol();
  }

  private applyPermissions() {
    const permission = this.permissionsService.getPermission(this.permissionUid);

    if (permission) {
      // Aplicamos el comportamiento dependiendo del tipo de item (BOTÓN o CAMPO)
      if (permission.item === 'Botón') {
        // Si el permiso está configurado para esconder el botón
        if (permission.view == 0) { 
          this.renderer.setStyle(this.el.nativeElement, 'display', 'none');
        }

        // Si el permiso está configurado para deshabilitar el botón
        if (permission.enable == 0) {
          this.renderer.setProperty(this.el.nativeElement, 'disabled', true);
        }
      }

      if (permission.item === 'Campo') {
        // Si el permiso está configurado para esconder el campo
        if (permission.view == 0) {
          this.renderer.setStyle(this.el.nativeElement, 'display', 'none');
        }
        // Si el permiso está configurado para deshabilitar el campo (readonly)
        if (permission.enable == 0) {
          this.renderer.setAttribute(this.el.nativeElement, 'readonly', 'true');
        }

        // Si el permiso está configurado para hacer el campo solo lectura
        if (permission.required == 1) {
          this.renderer.setAttribute(this.el.nativeElement, 'required', 'true');
        }
      }
    }
  }
}
